export class GrupoFinanceiro {}
